import { useCallback, useContext } from 'react';
import AnalyticsContext, { AnalyticsContextType } from '@/contexts/analytics/analytics-context';
import { trackClickEvent, trackEvent, EventProperties } from '@/services/analytics-service';
import { getPathStep, getRouteStep } from '@/services/location-service';

export function eventName(sourceString: string): string {
  const uppercase = sourceString.replace(/[a-z0-9]/g, (c) => c.toUpperCase());
  const sanitizedUppercase = uppercase.replace(/'/g, () => '');
  const segmented = sanitizedUppercase.split(/[^A-Z0-9]/g).filter((s) => s !== '');
  return segmented.join('_');
}

export function routeContext(): string {
  const { step_id } = getRouteStep();

  return step_id ? eventName(step_id) : 'APP_ENTRY';
}

export function pathContext(pathName: string): string {
  const { step_id } = getPathStep(pathName);

  return step_id ? eventName(step_id) : 'APP_ENTRY';
}

export default function useAnalytics() {
  const {
    eventPrefix,
    context: { quoteId, publicId, experience },
  } = useContext<AnalyticsContextType>(AnalyticsContext);

  return {
    trackClick: useCallback(
      (event: string, properties: EventProperties = {}) => {
        const eventProperties: EventProperties = {
          eventPrefix,
          quoteId,
          publicId,
          experience,
          ...properties,
        };
        trackClickEvent(routeContext(), event, eventProperties, quoteId);
      },
      [eventPrefix, quoteId, publicId, experience]
    ),
    trackEvent: useCallback(
      (event: string, properties: EventProperties = {}) => {
        const eventProperties: EventProperties = {
          eventPrefix,
          quoteId,
          publicId,
          experience,
          ...properties,
        };

        trackEvent(routeContext(), event, eventProperties, quoteId);
      },
      [eventPrefix, quoteId, publicId, experience]
    ),
  };
}
